import React, {Component, createRef} from 'react';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {consts} from '../../constants';
import {setInputLanguage, getLanguage} from '../../_shared/GWTBridge/invoke/common';
import {DefaultSearchDropdown} from './DefaultSearchDropdown';

interface Option {
    parent: Option;
    name: string;
    title: string;
}

interface SearchProps {
    options: Option[];
    placeholder: string;
    onOptionSelect?(option: Option): void;
    onSearchUpdate?(res: any): void;
    list?: ({
        data,
        onOptionSelect,
        maxHeight
    }: {
        data: any;
        onOptionSelect: (option: Option) => void;
        maxHeight: number;
    }) => JSX.Element;
    listMaxHeight?: number;
    renderItem?(item: any): JSX.Element;
    isRTL?: boolean;
}

export default class Search extends Component<SearchProps, {searchTerm: string}> {
    input;
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: ''
        };
        this.searchUpdated = this.searchUpdated.bind(this);
        this.selectOption = this.selectOption.bind(this);
        this.createFilter = this.createFilter.bind(this);
        this.clearSearchTerm = this.clearSearchTerm.bind(this);

        this.input = createRef();
    }

    componentDidMount() {
        this.input.focus();
    }
    componentDidUpdate(prevProps) {
        const res =
            this.state.searchTerm &&
            this.props.options.filter(option =>
                this.createFilter(option, this.state.searchTerm, consts.KEYS_TO_SEARCH_FILTER)
            );
        this.props.onSearchUpdate && this.props.onSearchUpdate(res);
    }

    searchUpdated(event) {
        this.setState({searchTerm: event.target.value});
    }

    selectOption(option) {
        this.props.onOptionSelect(option);
        this.setState({searchTerm: ''});

        // TODO: check that we don't need this
        //  if (this.props.panelType === panelTypes.PACKAGES) {
        // this.props.designScreen.hasExpendedTab = true;
        //  }
    }

    createFilter(option, searchTerm, keyToSearch) {
        return option[keyToSearch].toLowerCase().includes(searchTerm.toLowerCase());
    }

    clearSearchTerm() {
        this.setState({searchTerm: ''});
    }
    setInputLanguage() {
        const len = getLanguage();
        if (len === 1) {
            setInputLanguage('he');
        }
    }
    render() {
        const {placeholder, options, list: SearchList} = this.props;
        const filteredOptions =
            this.state.searchTerm &&
            options.filter(option =>
                this.createFilter(option, this.state.searchTerm, consts.KEYS_TO_SEARCH_FILTER)
            );
        return (
            <div>
                <div className="input-wrapper">
                    <input
                        ref={i => (this.input = i)}
                        className="search-input"
                        placeholder={placeholder}
                        value={this.state.searchTerm}
                        onChange={this.searchUpdated}
                        onFocus={() => {
                            this.setInputLanguage();
                        }}
                    />
                    {this.state.searchTerm.length === 0 ? (
                        <Icon
                            icon={PriorityIcon.searchThin}
                            componentClasses="search-module-input-svg"
                        />
                    ) : (
                        <Icon
                            icon={PriorityIcon.x}
                            skin="standart"
                            componentClasses="search-module-input-svg"
                            onClick={this.clearSearchTerm}
                        />
                    )}
                </div>
                {SearchList ? (
                    <SearchList
                        data={filteredOptions ? filteredOptions : options}
                        onOptionSelect={this.props.onOptionSelect}
                        maxHeight={this.props.listMaxHeight}
                    />
                ) : (
                    <DefaultSearchDropdown
                        data={filteredOptions}
                        onOptionSelect={option => this.selectOption(option)}
                    />
                )}
            </div>
        );
    }
}
